var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FaFileSignature } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { Table, Alert } from 'template/lib';
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import api from "../../services/api";
import ModalEditInteration from "../Modals/ModalEditInteration";
import ModalAceite from "../Modals/ModalAceite";
import { CiImport } from "react-icons/ci";
import RelatorioTemplate from './RelatorioTemplate';
import { renderToString } from "react-dom/server";
import ModalMySignature from '../Modals/ModalMySignature';
var Interation = function () {
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var setTitle = useTitle().setTitle;
    var history = useHistory();
    var _b = useState([]), helps = _b[0], setHelps = _b[1];
    var _c = useState([]), details = _c[0], setDetails = _c[1];
    var _d = useState(1), page = _d[0], setPage = _d[1];
    var _e = useState(15), pageSize = _e[0], setPageSize = _e[1];
    var _f = useState(false), hasNext = _f[0], setHasNext = _f[1];
    var _g = useState(0), totalPages = _g[0], setTotalPages = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(false), modalIsOpenEdit = _j[0], setModalIsOpenEdit = _j[1];
    var _k = useState(false), aceiteOpen = _k[0], setAceiteOpen = _k[1];
    var _l = useState(), idSelect = _l[0], setIdSelect = _l[1];
    var _m = useState(), idItem = _m[0], setIdItem = _m[1];
    var _o = useState([]), user = _o[0], setUser = _o[1];
    var _p = useState([]), detailsItem = _p[0], setDetailsItem = _p[1];
    var _q = useState(false), alertOpen = _q[0], setAlertOpen = _q[1];
    var _r = useState(''), message = _r[0], setMessage = _r[1];
    var _s = useState({}), countInteration = _s[0], setCountInteration = _s[1];
    var _t = useState(false), userChecked = _t[0], setUserChecked = _t[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var urlPendingHelps = "/signature/pendingSignature?page=" + page + "&pagesize=" + pageSize;
    var userRole = login === null || login === void 0 ? void 0 : login.role;
    function ModalIsCloseEdit() {
        setDetailsItem([]);
        setModalIsOpenEdit(false);
    }
    function ModalAceiteClose() {
        setAceiteOpen(false);
    }
    useEffect(function () {
        if (!helps || helps.length === 0)
            return;
        var hasChanges = false;
        var updatedHelps = helps.map(function (help) {
            var details = help.details || [];
            var allSigned = details.length > 0 && details.every(function (detail) { return detail.workItemSignature === true; });
            // só altera se o valor for diferente do atual
            if (help.workItemSignature !== allSigned) {
                hasChanges = true;
                return __assign(__assign({}, help), { workItemSignature: allSigned });
            }
            return help;
        });
        if (hasChanges) {
            setHelps(updatedHelps);
        }
    }, [helps]);
    var filter = function (id) {
        setIdItem(id);
        if (id !== null && Array.isArray(helps)) {
            // Marca todos como false, e só o selecionado como true
            var updatedHelps = helps.map(function (item) { return (__assign(__assign({}, item), { viewed: !(item.id === id) })); });
            // Encontra o item selecionado atualizado
            var selectedItem = updatedHelps.find(function (item) { return item.id === id; });
            if (!selectedItem)
                return;
            // Garante que os detalhes estão atualizados
            var updatedDetails = selectedItem.details.map(function (detail) { return (__assign({}, detail)); });
            // Atualiza os estados
            setHelps(updatedHelps);
            setDetails(updatedDetails);
            var signedCount = selectedItem.details.filter(function (detail) { return detail.workItemSignature === true; }).length;
            var totalCount = selectedItem.details.length;
            setCountInteration({ signedCount: signedCount, totalCount: totalCount });
        }
    };
    var filterUser = function (id) {
        setDetailsItem([]);
        if (id !== null && Array.isArray(helps)) {
            var selectedItem = details.find(function (item) { return item.id === id; });
            if (selectedItem) {
                // Cria uma cópia do item com a nova propriedade `disabled`
                var updatedItem = __assign(__assign({}, selectedItem), { disabled: selectedItem.workItemSignature === true });
                // Atualiza os estados
                setDetailsItem(updatedItem);
                setUser(updatedItem.users);
            }
        }
        return null;
    };
    var userDesabled = function (id) {
        // Reseta e abre modal
        setDetailsItem([]);
        setModalIsOpenEdit(true);
        setIdSelect(id);
        if (id !== null && Array.isArray(helps)) {
            // Adiciona a propriedade disabled em todos os itens
            var updatedDetails = details.map(function (item) { return (__assign(__assign({}, item), { disabled: true // todos terão a propriedade
             })); });
            // Encontra o item selecionado dentro da lista atualizada
            var selectedItem = updatedDetails.find(function (item) { return item.id === id; });
            if (selectedItem) {
                // Atualiza os estados principais
                setDetailsItem(selectedItem);
                setUser(selectedItem.users);
            }
            // Atualiza o estado global de detalhes
            setDetails(updatedDetails);
        }
        return null; // Caso não encontre
    };
    var clearDetails = function () {
        setDetails([]);
    };
    function mensage(mensage) {
        api.get(urlPendingHelps, config)
            .then(function (response) {
            try {
                var items = response.data.items;
                var today_1 = new Date();
                today_1.setHours(0, 0, 0, 0);
                // 1) Processa detalhes e marca atrasados + nova propriedade allFinished
                var itemsWithLate = items.map(function (item) {
                    var _a;
                    var updatedDetails = ((_a = item.details) === null || _a === void 0 ? void 0 : _a.map(function (detail) {
                        var limitDate = null;
                        if (detail.dataLimit) {
                            var _a = detail.dataLimit.split('/'), day = _a[0], month = _a[1], year = _a[2];
                            limitDate = new Date(+year, +month - 1, +day);
                            limitDate.setHours(0, 0, 0, 0);
                        }
                        var isLate = detail.finishDate === null &&
                            limitDate !== null &&
                            limitDate < today_1;
                        return __assign(__assign({}, detail), { isLate: isLate });
                    })) || [];
                    // Novo cálculo: todos detalhes finalizados?
                    var allFinished = updatedDetails.length > 0 &&
                        updatedDetails.every(function (d) { return Boolean(d.finishDate); });
                    // Pai é late se qualquer filho for late
                    var parentIsLate = updatedDetails.some(function (d) { return d.isLate; });
                    return __assign(__assign({}, item), { details: updatedDetails, isLate: parentIsLate, allFinished: allFinished // <-- NOVA PROPRIEDADE AQUI
                     });
                });
                // Atualiza estado principal
                setHelps(itemsWithLate);
                // Paginação
                var totalPages_1 = Math.ceil(response.data.totalCount / pageSize);
                setTotalPages(totalPages_1);
                setHasNext(totalPages_1 > page);
                // Se existe item sendo visualizado
                var selectedItem = itemsWithLate.find(function (item) { return item.id === idItem; });
                if (selectedItem) {
                    var updatedDetails = selectedItem.details;
                    var signedCount = updatedDetails.filter(function (detail) { return Boolean(detail.finishDate); }).length;
                    var totalCount = updatedDetails.length;
                    setCountInteration({ signedCount: signedCount, totalCount: totalCount });
                    // Atualiza viewed
                    var updatedHelps = itemsWithLate.map(function (item) { return (__assign(__assign({}, item), { viewed: !(item.id === idItem) })); });
                    setHelps(updatedHelps);
                    setDetails(updatedDetails);
                }
            }
            catch (e) {
                handleLogout();
                history.push('/');
            }
        })
            .finally(function () { return setLoading(false); });
    }
    var edit = function (id) {
        setDetailsItem([]);
        setModalIsOpenEdit(true);
        setIdSelect(id);
        filterUser(id);
    };
    var imprimir = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var pdfResponse, relatorioHTML, html, iframe, conteudo, doc;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, api.get("/signature/pdf/" + id, config)];
                case 1:
                    pdfResponse = _b.sent();
                    relatorioHTML = _jsx(RelatorioTemplate, __assign({}, pdfResponse.data), void 0);
                    html = renderToString(relatorioHTML);
                    iframe = document.createElement("iframe");
                    iframe.style.position = "fixed";
                    iframe.style.right = "0";
                    iframe.style.bottom = "0";
                    iframe.style.width = "0";
                    iframe.style.height = "0";
                    iframe.style.border = "none";
                    iframe.setAttribute("aria-hidden", "true");
                    document.body.appendChild(iframe);
                    conteudo = "\n          <html>\n            <body>" + html + "</body>\n          </html>\n        ";
                    doc = iframe.contentDocument || ((_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
                    if (!doc) {
                        console.error("Não foi possível acessar o documento do iframe.");
                        return [2 /*return*/];
                    }
                    doc.open();
                    doc.write(conteudo);
                    doc.close();
                    // Aguarda o conteúdo ser renderizado e imprime
                    setTimeout(function () {
                        var win = iframe.contentWindow;
                        if (win) {
                            win.focus();
                            win.print();
                        }
                        setTimeout(function () { return iframe.remove(); }, 1000);
                    }, 500);
                    return [2 /*return*/];
            }
        });
    }); };
    var sign = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var checkedUser, selectedDetail;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIdSelect(id);
                    return [4 /*yield*/, api.get("/signature/getSignatureBase64", config)];
                case 1:
                    checkedUser = _a.sent();
                    if (checkedUser.data) {
                        if (!Array.isArray(details)) {
                            return [2 /*return*/];
                        }
                        selectedDetail = details.find(function (detail) { return detail.id === id; });
                        if (!selectedDetail) {
                            return [2 /*return*/];
                        }
                        // Valida campos obrigatórios com mensagens padronizadas
                        if (!selectedDetail.finishDateFormatted) {
                            setMessage('Campo de Data Realizada está inválido.');
                            setAlertOpen(true);
                            return [2 /*return*/, false];
                        }
                        if (!selectedDetail.workComments) {
                            setMessage('Campo de Descrição está inválido.');
                            setAlertOpen(true);
                            return [2 /*return*/, false];
                        }
                        if (!selectedDetail.users || selectedDetail.users.length === 0) {
                            setMessage('⚠️ Nenhum usuário selecionado! Por favor, selecione ao menos um usuário.');
                            setAlertOpen(true);
                            return [2 /*return*/, false];
                        }
                        // Todos os campos válidos
                        setAceiteOpen(true);
                    }
                    else {
                        console.log("teste");
                        setUserChecked(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var closeSignature = function () {
        setUserChecked(false);
    };
    // 2. Inicialize o array
    var lineBtnsWithoutAssginTo = [];
    if (userRole === "Customer" || userRole === "CustomerAdmin") {
        lineBtnsWithoutAssginTo.push({
            name: "Detalhes",
            icon: _jsx(BsSearch, {}, void 0),
            fn: function (id) { return filter(id); },
        });
    }
    else {
        lineBtnsWithoutAssginTo.push({
            name: "Detalhes",
            icon: _jsx(BsSearch, {}, void 0),
            fn: function (id) { return filter(id); },
        });
    }
    var lineBtnsWithoutAssgin = [];
    if (userRole === "Customer" || userRole === "CustomerAdmin") {
        lineBtnsWithoutAssgin.push({
            name: "Detalhe",
            icon: _jsx(FaEdit, {}, void 0),
            fn: function (id) { return userDesabled(id); },
        }, {
            name: "Assinar",
            icon: _jsx(FaFileSignature, {}, void 0),
            fn: function (id) { return sign(id); },
        }, {
            name: "Imprimir",
            icon: _jsx(CiImport, {}, void 0),
            fn: function (id) { return imprimir(id); },
        });
    }
    else {
        lineBtnsWithoutAssgin.push({
            name: "Editar",
            icon: _jsx(FaEdit, {}, void 0),
            fn: function (id) { return edit(id); },
        }, {
            name: "Assinar",
            icon: _jsx(FaFileSignature, {}, void 0),
            fn: function (id) { return sign(id); },
        }, {
            name: "Imprimir",
            icon: _jsx(CiImport, {}, void 0),
            fn: function (id) { return imprimir(id); },
        });
    }
    useEffect(function () {
        setTitle('Minhas Interações');
        if (!login) {
            history.push('/');
        }
        if (login && Date.now() > (login === null || login === void 0 ? void 0 : login.expiresIn) * 1000) {
            handleLogout();
            history.push('/');
        }
        api.get(urlPendingHelps, config)
            .then(function (response) {
            try {
                var items = response.data.items;
                var today_2 = new Date();
                today_2.setHours(0, 0, 0, 0);
                // 1) Processa detalhes e marca atrasados + nova propriedade allFinished
                var itemsWithLate = items.map(function (item) {
                    var _a;
                    var updatedDetails = ((_a = item.details) === null || _a === void 0 ? void 0 : _a.map(function (detail) {
                        var limitDate = null;
                        if (detail.dataLimit) {
                            var _a = detail.dataLimit.split('/'), day = _a[0], month = _a[1], year = _a[2];
                            limitDate = new Date(+year, +month - 1, +day);
                            limitDate.setHours(0, 0, 0, 0);
                        }
                        var isLate = detail.finishDate === null &&
                            limitDate !== null &&
                            limitDate < today_2;
                        return __assign(__assign({}, detail), { isLate: isLate });
                    })) || [];
                    // Novo cálculo: todos detalhes finalizados?
                    var allFinished = updatedDetails.length > 0 &&
                        updatedDetails.every(function (d) { return Boolean(d.finishDate); });
                    // Pai é late se qualquer filho for late
                    var parentIsLate = updatedDetails.some(function (d) { return d.isLate; });
                    return __assign(__assign({}, item), { details: updatedDetails, isLate: parentIsLate, allFinished: allFinished // <-- NOVA PROPRIEDADE AQUI
                     });
                });
                // Atualiza estado principal
                setHelps(itemsWithLate);
                // Paginação
                var totalPages_2 = Math.ceil(response.data.totalCount / pageSize);
                setTotalPages(totalPages_2);
                setHasNext(totalPages_2 > page);
                // Se existe item sendo visualizado
                var selectedItem = itemsWithLate.find(function (item) { return item.id === idItem; });
                if (selectedItem) {
                    var updatedDetails = selectedItem.details;
                    var signedCount = updatedDetails.filter(function (detail) { return Boolean(detail.finishDate); }).length;
                    var totalCount = updatedDetails.length;
                    setCountInteration({ signedCount: signedCount, totalCount: totalCount });
                    // Atualiza viewed
                    var updatedHelps = itemsWithLate.map(function (item) { return (__assign(__assign({}, item), { viewed: !(item.id === idItem) })); });
                    setHelps(updatedHelps);
                    setDetails(updatedDetails);
                }
            }
            catch (e) {
                handleLogout();
                history.push('/');
            }
        })
            .finally(function () { return setLoading(false); });
    }, [page, pageSize]);
    useEffect(function () {
        setInterval(function () {
            setAlertOpen(false);
        }, 15000);
    }, [alertOpen]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'pb-20 h-screen ' }, { children: [alertOpen &&
                        _jsx("div", __assign({ style: {
                                position: 'fixed',
                                top: '80px',
                                right: 0
                            } }, { children: _jsx(Alert, __assign({ info: false }, { children: message }), void 0) }), void 0), _jsxs("div", __assign({ className: 'overflow-auto h-full' }, { children: [_jsx(Table, { loading: loading, setSize: setPageSize, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, data: helps, totalPAges: totalPages, lineButton: lineBtnsWithoutAssginTo, title: 'Intera\u00E7\u00F5es', columns: [
                                    { label: 'ID', key: 'id', eventClick: lineBtnsWithoutAssginTo[0].fn },
                                    { label: 'Cliente', key: 'clientName', maxLenghtToShowSeeMore: 90 },
                                    { label: 'Título', key: 'title', maxLenghtToShowSeeMore: 180 },
                                    { label: 'Status', key: 'status' },
                                    { label: 'Data Início', key: 'startDate' },
                                    { label: 'Data Fim', key: 'finishDate' }
                                ] }, void 0), _jsx(Table, { loading: loading, page: page, setPage: setPage, data: details, totalPAges: totalPages, title: 'Tarefas da Intera\u00E7\u00E3o', lineButton: lineBtnsWithoutAssgin, columns: [
                                    { label: 'Id', key: 'id', eventClick: lineBtnsWithoutAssginTo[0].fn },
                                    { label: 'Data Limite', key: 'dataLimit' },
                                    { label: 'Titulo', key: 'title', maxLenghtToShowSeeMore: 180 },
                                    { label: 'Especificação', key: 'especification', maxLenghtToShowSeeMore: 90 },
                                    { label: 'Status', key: 'status' },
                                    { label: 'Horas Previstas', key: 'estimatedHours' },
                                    { label: 'Horas Realizadas', key: 'workedHours' },
                                    { label: 'Data Finalização', key: 'finishDateFormatted' },
                                ] }, void 0)] }), void 0)] }), void 0), _jsx(ModalEditInteration, { handleOpenModalEdit: modalIsOpenEdit, handleCloseModalEdit: ModalIsCloseEdit, idItem: idSelect, usersItem: user, mensage: mensage, details: detailsItem }, void 0), _jsx(ModalAceite, { handleOpenModalEdit: aceiteOpen, handleCloseModalEdit: ModalAceiteClose, idItem: idSelect, mensage: mensage, countInteration: countInteration, idSelect: idItem, clear: clearDetails }, void 0), _jsx(ModalMySignature, { handleOpenModalSignature: userChecked, handleCloseModalSignature: closeSignature, idItem: idSelect, sign: sign }, void 0)] }, void 0));
};
export default Interation;
